const objectives = [
    {
      title: "Objectives",
      description: [
        "Ethical AI Development: Foster AI systems that are fair, accountable, and aligned with societal values.",
        "Enhanced Privacy and Security: Innovate in protecting data privacy and developing robust security measures.",
        "Explainable AI: Develop AI models that are transparent and interpretable, making their decision-making processes clear and understandable.",
        "Integration of Social Sciences and Humanities: Ensure that AI and Data Science are developed and evaluated in the context of their broader social, cultural, and ethical implications."
      ]
    },
    {
      title: "Research Interests",
      description: [
        "Responsible AI: Create AI systems with embedded ethical principles.",
        "Data Privacy and Security: Develop cutting-edge solutions for data protection and cybersecurity.",
        "Explainable Machine Learning: Focus on methods and tools that make AI decisions transparent and understandable.",
        "Social and Humanistic AI Studies: Explore the societal, ethical, and cultural dimensions of AI."
      ]
    },
   
  ];
  export default objectives